import Vue from 'vue'
import VueRouter from 'vue-router'

// 重写push方法，不然当路由跳转到当前路由会报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const _import_ = file => () => import('../views/' + file + '.vue')

// hideBread： 是否隐藏面包屑
const routes = [
  {
    path: '',
    name: 'layout',
    component: _import_('layout'),
    children: [
      {
        path: '/',
        name: 'home',
        component: _import_('home/index'),
        meta: {
          title: '首页',
          breadList: []
        }
      },
      {
        path: '/environment',
        name: 'environment',
        component: _import_('environment/index'),
        meta: {
          title: '环境库',
          // loginRequired: true,
          belong: 'environment',
          breadList: ['environment']
        }
      },
      {
        path: '/environment/:id',
        name: 'environment-detail',
        component: _import_('environment/detail'),
        meta: {
          title: '环境详情',
          // loginRequired: true,
          belong: 'environment',
          breadList: ['environment', 'environment-detail']
        }
      },
      {
        path: '/case_detail',
        name: 'case_detail',
        component: _import_('environment/caseDetail'),
        meta: {
          title: '案例详情',
          loginRequired: true,
          belong: 'environment',
          breadList: ['environment']
        }
      },
      {
        path: '/combat_camp',
        name: 'combat_camp',
        component: _import_('combat-camp/index'),
        meta: {
          title: '实战营',
          loginRequired: true,
          belong: 'combat_camp',
          breadList: ['combat_camp']
        }
      },
      {
        path: '/combat_camp_detail',
        name: 'combat_camp_detail',
        component: _import_('combat-camp/detail'),
        meta: {
          title: '项目详情',
          loginRequired: true,
          belong: 'combat_camp',
          breadList: ['combat_camp']
        }
      },
      {
        path: '/combat_camp_tpl_detail',
        name: 'combat_camp_tpl_detail',
        component: _import_('combat-camp/tplDetail'),
        meta: {
          title: '模版详情',
          loginRequired: true,
          belong: 'combat_camp',
          breadList: ['combat_camp']
        }
      },
      {
        path: '/task',
        name: 'task',
        component: _import_('task/index'),
        meta: {
          title: '任务库',
          // loginRequired: true,
          belong: 'task',
          breadList: ['environment', 'task']
        }
      },
      {
        path: '/task/:id',
        name: 'task-detail',
        component: _import_('task/detail'),
        meta: {
          title: '任务详情',
          loginRequired: true,
          belong: 'task',
          breadList: ['task', 'task-detail']
        }
      },
      {
        path: '/task-edit',
        name: 'task-edit',
        component: _import_('task/createTask'),
        meta: {
          title: '编辑任务',
          loginRequired: true,
          belong: 'task',
          breadList: ['task', 'task-edit']
        }
      },
      {
        path: '/faucet',
        name: 'faucet',
        component: _import_('faucet/index'),
        meta: {
          title: '水龙头',
          loginRequired: false,
          breadList: [],
          hideBread: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: _import_('login/index')
  },
  {
    path: '/invite',
    name: 'invite',
    component: _import_('invite/index')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
